import cn from 'classnames';
import styles from './Checkbox.module.scss';
import { UseFormRegister } from 'react-hook-form';
import { ReactNode } from 'react';

type CheckboxProps = {
  label: ReactNode;
  name: string;
  register: UseFormRegister<any>;
  required?: boolean;
  className?: string;
  onChange?: () => void;
};

export function Checkbox({
  label,
  name,
  register,
  required,
  className,
}: CheckboxProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName}>
      <input
        type="checkbox"
        {...register(name, { required })}
        className={styles.input}
      />
      <p className={styles.label}>{label}</p>
    </div>
  );
}
